import { Navigate, useLocation } from "react-router-dom";

/**
 * Legacy contracts used to have a bulk page of their own. Both kinds now start
 * from Bulk Import Contracts, so an old link (or a bookmarked run) lands there.
 */
const BulkLegacyContract = () => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: "/contracts/bulk", search }} replace />;
};

export default BulkLegacyContract;
